import { object, string } from "yup";

export const facebookAccSchema = () => {
    const schema = {
        page_id: string().required("COMMON.Required_Input").matches(/^\d+$/, "FBSETTING.PageId_DigitOnly"),
        secret: string().required("COMMON.Required_Input"),
        //verify_token: string().required("COMMON.Required_Input"),
    };
    return object().shape(schema);
};
